import {
  SITENAMEALIAS,
  WEBSERVICE,
  LIVE_WEBSERVICE,
  RECURRINGPAYMENT,
  REFUND,
  ACCOUNTS_WEBSERVICE,
  isTestMode,
} from "./init";
import Swal from "sweetalert2";
const qs = require("qs");
const axios = require("axios");
const shoppingBaseUrl = WEBSERVICE + "/shopping";

export const getAuthToken = () => {
  const key = isTestMode ? SITENAMEALIAS + "_test_access_token" : SITENAMEALIAS + "_access_token";
  return localStorage.getItem(key);
};

export const getAuthUuid = () => {
  const key = isTestMode ? SITENAMEALIAS + "_test_uuid" : SITENAMEALIAS + "_uuid";
  return localStorage.getItem(key);
};

const headers = { headers: { "Content-Type": "application/json" } };
const bbcheaders = {
  headers: {
    "Content-Type": "application/json",
    Origin: "https://billbitcoins.com",
  },
};
const authHeaders = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "bearer " + getAuthToken(),
    UUID: getAuthUuid(),
  },
};

export const GetTestUserToken = (payload) => {
  return axios.post(
    WEBSERVICE + "/merchant/login-test-mode",
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const PurgeData = (payload) => {
  return axios.post(
    WEBSERVICE + "/merchant/purge_data",
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const RemoveSubMerchant = (payload) => {
  return axios.post(
    WEBSERVICE + "/merchant/remove-sub-merchant",
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/* 

Method defination for login 
*/
// const token = localStorage.getItem(SITENAMEALIAS + '_access_token')
// const lastFewCharOfToken = token.substring(token.length - 4)
// console.log('last character of token', lastFewCharOfToken)

export const MerchantLogin = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(LIVE_WEBSERVICE + "/merchant/login", payload, headers);
};
/* 
Method defination for two factor auth login 
*/
export const TwoFactorLogin = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(LIVE_WEBSERVICE + "/merchant/TwoFactorLogin", payload, headers);
};

export const checkMgaStatus = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    LIVE_WEBSERVICE + "/merchant/checkMGAStatus",
    payload,
    headers
  );
};

export const checkTwoFactorAuth = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    LIVE_WEBSERVICE + "/merchant/CheckTwoFactor",
    payload,
    headers
  );
};

export const checkTwoFactorAuthSettings = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/CheckTwoFactorSettings",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/* 
Method defination for merchant forgot password 
*/

export const MerchantForgotPassword = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/ForgotPassword", payload, headers);
};

/* 
Method defination for merchant reset password 
*/

export const MerchantResetPassword = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/ResetPassword", payload, {
    headers: {
      "Content-Type": "application/json",
      //Authorization: "bearer " + getAuthToken(),
      //UUID: getAuthUuid(),
    },
  });
};

/* 
Method defination for fetch merchant status
*/

export const FetchMerchantStatus = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/FetchMerchantStatus",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/* 
Method defination for get all transaction
*/
export const GetAllTransactions = (obj) => {
  var payload = JSON.stringify(obj);
  return axios.post(WEBSERVICE + "/merchant/GetAllTransactions", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/* 
Method defination for merchant registration
*/

export const Registration = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(LIVE_WEBSERVICE + "/merchant/registration", payload, headers);
};

export const loginDetails = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    LIVE_WEBSERVICE + "/merchant/loginDetails",
    payload,
    headers
  );
};
/* 
Method defination for merchant registration
*/

export const ValidateRegistration = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    LIVE_WEBSERVICE + "/merchant/ValidateRegistration",
    payload,
    headers
  );
};
/* 
Method defination for resending email confirmation in get started page 
*/

export const ResendEmailConfirm = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/ResendEmailConfirm", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/* 
Method defination for checking email if it's already exist or not
*/

export const EmailCheck = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(LIVE_WEBSERVICE + "/merchant/emailCheck", payload, headers);
};
/* 
Method defination for retrieving basic information of merchant
*/

export const FetchBasicVerification = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/FetchBasicVerification", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/* 
Method defination for retrieving basic information of merchant
*/

export const FetchAllIndustry = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/FetchAllIndustry", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/* 
Method defination for posting basic verification
*/

export const BasicVerificationSubmit = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/BasicVerification", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/* 
Method defination for retrieving asset address 
*/

export const getCryptoAddress = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/getCryptoAddress", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/* 
Method defination for API for saving crypto address
*/

export const AddCryptoAddress = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/AddCryptoAddress", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/* 
Method defination for API for saving crypto address
*/

export const FetchPerDayTotalBTCTracsaction = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/FetchPerDayTotalBTCTracsaction",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
/* 
Method defination for API for retriveing total and average sale
*/

export const FetchTotalAverageSale = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/FetchTotalAverageSale",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
/* 
Method defination for API for rendeing chart for success ful and unsucccess full txn
*/

export const FetchPerDaySuccessUnsuccessTransacCount = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/FetchPerDaySuccessUnsuccessTransacCount",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
/* 
Method defination for API for rendeing crypto ledger amount
*/

export const FetchUsdBtcLedgerAmount = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/FetchUsdBtcLedgerAmount",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const getFeesByCurrencyId = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/getFeesByCurrencyId", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/* 
Method defination for API for rendeing invoice list for all payments
*/

export const GetAllInvoices = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/get_all_invoices", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/* 
Method defination for API for rendeing invoice list for paid payments
*/
export const GetAllPaidResolvedInvoice = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/get_all_paid_resolved_invoice",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
/* 
Method defination for API for rendeing invoice list for unresolved payments
*/

export const getAllUnresolvedInvoice = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/get_all_unresolved_invoice",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
/* 
Method defination for API for rendeing invoice list using search string
*/

export const searchAllInvoices = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/search_all_invoices", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*Method defination for API for rendeing email bill list
 */

export const GetAllEmailBills = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/get_all_email_bills", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*Method defination for API for new email bill
 */

export const addNewEmailBill = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/add_new_email_bill", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*Method defination for API for new email bill
 */

export const getAllHostedCatalogs = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/get_all_hosted_catalogs", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for deleting hosted catalog
*/

export const DeleteHostedCatalog = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/delete_hosted_catalog", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for adding hosted catalog
*/

export const AddNewHostedCatalog = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/add_new_hosted_catalog", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for updating hosted catalog
*/

export const UpdateHostedCatalog = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/update_hosted_catalog", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for deleting hosted catalog
*/

export const GetHostedCatalog = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/get_hosted_catalog", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*
Method defination for API for saving users settings data
*/

export const SaveBasicUserSettings = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/SaveUserSettings",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
export const SaveTwoFactorSettings = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/SaveTwoFactorSettings",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
/*
Method defination for API for retrieving users settings data
*/

export const FetchUserSettings = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/FetchUserSettings",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
/*
Method defination for API for chnaging user password
*/

export const ChangePassword = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/MerchantDashboard/ChangePassword", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*
Method defination for API for retrieving app settings data
*/

export const FetchMerchantSettings = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/FetchMerchantsettings", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for updating order settings data
*/

export const SetNotifiEmail = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/SetNotifiEmail", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for fetching a particular email bill data
*/

export const GetEmailBill = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/get_email_bill", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for updating a particular email bill data
*/

export const UpdateEmailBill = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/update_email_bill", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for deleting a bill
*/

export const DeleteEmailBill = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/delete_email_bill", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for sending a bill
*/

export const SendEmailBill = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/send_email_bill", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for fetching activated volume data
*/

export const FetchActivatedVolume = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/FetchActivatedVolume", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for update  activated volume data
*/

export const UpdateVolumeId = (payload) => {
  return axios.post(WEBSERVICE + "/merchant/submitVolumeRequest", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for Sending amount to external wallet
*/

export const SendToOther = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/sendToOther", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/* send otp while transfer to external wallet security check */
export const coinSendToOther = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/SendOtp/coinsendtoother", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*
Method defination for API for uploading tax file for activating volume data
*/

export const UploadFile = (payload) => {
  return axios.post(WEBSERVICE + "/merchant/UploadFile", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for fetching merchant profile
*/

export const FetchMerchantProfile = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/FetchMerchantProfile", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/*
Method defination for API for updating merchant profile
*/

export const AddMerchantProfile = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/AddMerchantProfile", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*Method defination for API for ipgeolocation
 */

export const ipgeolocation = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.get(
    "https://api.ipgeolocation.io/ipgeo?apiKey=693da481af1b4a3e80e3dfea9115dc52",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
/* Method defination to get converted price */
export const GetMarketPrice = (currency) => {
  return axios.get(
    WEBSERVICE + "/merchant/getMarketPrice?counter=" + currency,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
/*Method defination for API for paybito login for withdraw
 */

export const paybitoLogin = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/LoginWithUsernamePassword",
    payload,
    headers
  );
};
export const userAccountStatus = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/userAccountStatus",
    payload,
    headers
  );
};

// Method defination for Forgot password API

export const paybitoForgotPassword = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/ForgotPassword",
    payload,
    headers
  );
};
export const paybitoResetPassword = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/ResetPassword",
    payload,
    headers
  );
};
export const checkBroker = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/CheckBroker",
    payload,
    headers
  );
};

export const paybitoSentOtp = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/SendOtp/securetoken",
    payload,
    headers
  );
};

export const paybitoLoginMobileOtp = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/sendMobileOtp/login",
    payload,
    headers
  );
};

export const paybitoSentOtpForLogin = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/SendOtp/login",
    payload,
    headers
  );
};

export const paybitoSignUp = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/AddUserDetails",
    payload,
    headers
  );
};
/* API defination for paybito's resend OTP */
export const ResendOTP = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/ResendOTP/coinregistration",
    payload,
    headers
  );
};
/* API defination for paybito's resend OTP */
export const CheckMfaStatus = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/checkMfaStatus",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Origin: "https://billbitcoins.com/app/v2/ui/",
      },
    }
  );
};

export const CheckOTP = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/CheckOTP",
    payload,
    headers
  );
};

// balence transfer to paybito
export const transferBalencetoPaybito = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/TransferToPaybito", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
// get user's all transactions
export const GetUserTransaction = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/getUserTransaction", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
// get merchant's settings data
export const GetMerchantSettings = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/GetMerchant_settings", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
// get merchant's settings data
export const SetMerchantSettings = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/SetMerchant_settings", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
// get merchant's settings data
export const CaptchaVerify = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/captcha/verify", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
export const googleTwoFactorAuth = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/GetTwoFactorykey",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const checkTwoFactorLogin = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    ACCOUNTS_WEBSERVICE + "/api/user/CheckTwoFactor",
    payload,
    headers
  );
};
export const isCryptoAddrValid = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/addressValidate",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
export const getFees = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/getFees",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const getSignUpEmailOtp = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(LIVE_WEBSERVICE + "/merchant/sendEmailOtp", payload, headers);
};
export const getSignUpPhoneOtp = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    LIVE_WEBSERVICE + "/merchant/sendMobileOtpWithAction/registrationmobileotp",
    payload,
    headers
  );
};
export const smsAuthPhoneOtp = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/sendMobileOtpWithAction/loginmobileotp",
    payload,
    headers
  );
};
export const getRegister = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/registration", payload, headers);
};
export const checkPhoneNo = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(LIVE_WEBSERVICE + "/merchant/checkPhoneNo", payload, headers);
};
export const userPhoneSmsOtpVerification = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/velidateLoginMobileOtp",
    payload,
    headers
  );
};
export const userPhoneNumberCheck = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/checkPhoneForBasicVerification",
    payload,
    headers
  );
};

export const verifyRegistredPhoneNo = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/validateChangePhoneNumberOtp",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const phoneAuthEnable = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/SavePhoneAuthSettings",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
export const phoneAuthDisable = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/MerchantDashboard/phone_auth_off_settings",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
export const sendOtpForTwoFa = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/SendOtp/2faemailotp", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
export const sendOtpInRegNo = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/sendMobileOtpWithAction/changephonemobileotp",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const changeMobileNo = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/merchant/changeMobileNo",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const emailValidationAtLogin = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    LIVE_WEBSERVICE + "/merchant/SendEmailOtp/EmailLogin",
    payload,
    headers
  );
};

/* 
Method definition for Recurring Payment API - customer email validation
*/
export const get_customer_details = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(RECURRINGPAYMENT + "/get_customer_details", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/** */

/* 
Method definition for Recurring Payment API - send payment request
*/
export const send_payment_request = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(RECURRINGPAYMENT + "/send_payment_request", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

/** */

/* 
Method definition for Recurring Payment API - get request list
*/
export const get_request_list = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(RECURRINGPAYMENT + "/get_request_list", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/** */

/* 
Method definition for Recurring Payment API - update status
*/
export const update_payment_status = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(RECURRINGPAYMENT + "/update_payment_status", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/** */

/* 
Method definition for Recurring Payment API - refund list
*/
export const get_refund_list = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(REFUND + "/getRefunds", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/** */

/* 
Method definition for Recurring Payment API - refund list
*/
export const cancelSubscription = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(
    WEBSERVICE + "/payment/cancelSubscription",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const update_refund_status = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(RECURRINGPAYMENT + "/update_refund_status", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*
Method definition for fetching network fees for a refund
*/
export const get_network_fees = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(REFUND + "/getFees", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*
Method definition for creating a refund
*/
export const create_refund = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(REFUND + "/createRefund", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/** */

/*
Method definition for submitting refund wallet address
*/
export const submitRefundAddress = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/submitRefundAddress", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateRefundAddress = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/refund/updateRefundAddress", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getRefundDetails = (token) => {
  return axios.get(WEBSERVICE + "/refund/getRefundDetails", {
    params: { token },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

/** */

export const getBrokerDetails = (domain) => {
  return getBrokerDetailsByBrokerId("ATHA24102025105924");
};

export const getBrokerDetailsByBrokerId = (brokerId) => {
  const selectedBrokerId = brokerId || "ATHA24102025105924";
  return axios.get(
    ACCOUNTS_WEBSERVICE + "/api/home/getBrokerWiseExchangeInfo?brokerId=" +
    selectedBrokerId,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
export const GetAllMenus = async () => {
  return axios.get(WEBSERVICE + "/merchant/getAllMenus", {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const CreateSubMerchant = async (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/createSubMerchant", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
export const GetSubMerchantList = async (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/getSubMerchantList", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
export const UpdateAccessLevel = async (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/updateAccessLevel", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
/* 
Method defination for API for making user as test/real user
*/

export const updateInvoiceStatus = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/updateInvoiceStatus", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
export const GetTestInvoices = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/get_test_invoices", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const sendEmailOtpForUpdate = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/sendOtp/updateEmail", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const updateMerchantEmail = (obj) => {
  var payload = JSON.stringify(obj);

  return axios.post(WEBSERVICE + "/merchant/verifyOtp/updateEmail", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const AutoLoginPayments = async (platform, obj) => {
  var payload = JSON.stringify(obj);
  return axios.post(
    platform === "exchange"
      ? `${LIVE_WEBSERVICE}/merchant/exchange/auto-login-payments`
      : `${LIVE_WEBSERVICE}/merchant/launch-platform/auto-login-payments`,
    payload,
    headers
  );
};
export const GetUserBankDetails = async () => {
  var payload = JSON.stringify({
    uuid: localStorage.getItem(SITENAMEALIAS + "_exchange_uuid"),
  });
  return axios.post(`${WEBSERVICE}/kyc/GetUserBankDetails`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/* Function definition to update user bank details */
export const UpdateUserBankDetails = async (payload) => {
  const isFormData = payload instanceof FormData;
  const response = await axios.post(
    `${WEBSERVICE}/kyc/UpdateUserBankDetails-v2`,
    payload,
    {
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
  return response;
};
export const CreateWithdrawalRequest = async (payload) => {
  const response = await axios.post(
    `${WEBSERVICE}/kyc/createWithdrawalRequest`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
  return response;
};
export const GetUserDetails = async () => {
  var payload = JSON.stringify({
    uuid: localStorage.getItem(SITENAMEALIAS + "_exchange_uuid"),
  });
  return axios.post(`${WEBSERVICE}/kyc/GetUserDetails`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
export const GetTransactionLimitByTier = async (currencyCode, tierType) => {
  var payload = JSON.stringify({
    userUuid: localStorage.getItem(SITENAMEALIAS + "_exchange_uuid"),
    currency: currencyCode,
    tierType: tierType,
  });
  return axios.post(`${WEBSERVICE}/kyc/getTransactionLimitByTier`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
export const ConvertPrice = async (counterAsset, baseAsset) => {
  var payload = JSON.stringify({
    currency: counterAsset,
    baseCurrency: baseAsset,
    action: 2,
  });
  return axios.post(`${WEBSERVICE}/kyc/convertPrice`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};
export const ChangeProcessingFeeStatus = async (merchantId, status) => {
  var payload = JSON.stringify({
    merchantId: merchantId,
    status: status,
  });
  return axios.post(
    `${WEBSERVICE}/processing-fee/create`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
export const CalculateTransactionFee = async (
  merchantId,
  currencyId,
  amount
) => {
  const payload = {
    merchantId: merchantId,
    currencyId: currencyId,
    amount: parseFloat(amount),
  };
  return axios.post(
    `${WEBSERVICE}/payment/calculateTransactionFee`,
    JSON.stringify(payload),
    headers
  );
};

export const DashboardPaymentHistory = async (merchantId) => {
  return axios.get(`${WEBSERVICE}/payment/getPaymentHistory/${merchantId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const GetTransactionsByFilter = (payload) => {
  return axios.post(
    `${WEBSERVICE}/api/transactions/byFilter`,
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const UploadProfilePicture = (merchantId, file) => {
  var formData = new FormData();
  formData.append("merchant_id", merchantId);
  formData.append("uuid", getAuthUuid());
  formData.append("profile_picture", file);

  return axios.post(WEBSERVICE + "/merchant/uploadProfilePicture", formData, {
    headers: {
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const GetProfilePicture = (uuid) => {
  return axios.get(WEBSERVICE + "/merchant/getProfilePicture/" + uuid, {
    headers: {
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
    responseType: "blob",
  });
};

/* ─── Insights Analytics API Functions ──────────────────────────────── */

export const FetchMerchantKeyMetrics = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantKeyMetrics",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

export const FetchMerchantRevenueOverTime = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantRevenueOverTime",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

export const FetchMerchantTransactionHealth = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantTransactionHealth",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

/*
Method definition for Payment Source Performance API
Returns breakdown of revenue and transaction count per payment type (Payment_Link, Invoice, etc.)
*/
export const FetchMerchantPaymentSourcePerformance = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantPaymentSourcePerformance",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

/*
Method definition for Top Products API
Returns top-performing products/payment links by revenue and transaction count
*/
export const FetchMerchantTopProducts = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantTopProducts",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

/*
Method definition for Transaction Size Distribution API
Returns bucketed histogram data of transaction sizes
*/
export const FetchMerchantTxnSizeDistribution = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantTxnSizeDistribution",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

/*
Method definition for Geographic Distribution API
Returns transaction counts by country for the merchant
*/
export const FetchMerchantGeographicDistribution = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantGeographicDistribution",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

/*
Method definition for Failure Transaction Summary API
Returns breakdown of failed transactions by reason
*/
export const FetchMerchantFailureTxnSummary = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantFailureTxnSummary",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

export const FetchMerchantReports = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantReports",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

// Add this to your service.js file if it's not already there
export const FetchMerchantSettlementOverview = (payload) =>
  axios.post(
    WEBSERVICE + "/MerchantDashboard/getMerchantSettlementOverview",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );

// Add these functions to your existing service.js file

// ── Get All Products ───────────────────────────────────────────
export const GetAllProducts = (merchantId) => {
  return axios.get(`${shoppingBaseUrl}/products?merchantId=${merchantId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

// ── Get Product by ID ──────────────────────────────────────────
export const GetProductById = (merchantId, productId) => {
  return axios.get(`${shoppingBaseUrl}/products/${merchantId}/${productId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

// ── Register Products ──────────────────────────────────────────
export const RegisterProducts = (payload) => {
  return axios.post(`${shoppingBaseUrl}/products/register`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

// ── Upload Product Image ───────────────────────────────────────
export const UploadProductImage = (productId, formData) => {
  return axios.post(
    `${shoppingBaseUrl}/products/${productId}/image`,
    formData,
    {
      // headers: {
      //   ...getHeaders(),
      //   'Content-Type': 'multipart/form-data',
      // },
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

// ── Delete Product (if available) ──────────────────────────────
export const DeleteProduct = (merchantId, productId) => {
  return axios.delete(
    `${shoppingBaseUrl}/products/${merchantId}/${productId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

// ── Buyer Information API Functions ───────────────────────────────────────────
// Add these four functions to your existing utils/service.js file

/*
GET /buyer-information/:merchantId
Fetch all buyer information profiles for a merchant
*/
export const GetBuyerInformation = (merchantId) => {
  return axios.get(`${WEBSERVICE}/buyer-information/${merchantId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*
POST /buyer-information
Create a new buyer information profile
*/
export const SaveBuyerInformation = (obj) => {
  return axios.post(`${WEBSERVICE}/buyer-information`, JSON.stringify(obj), {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

/*
POST /buyer-information/update/:id
Update an existing buyer information profile
Note: customFieldId in payload is lowercase (unlike POST's CustomFieldId)
*/
export const UpdateBuyerInformation = (id, obj) => {
  return axios.post(
    `${WEBSERVICE}/buyer-information/update/${id}`,
    JSON.stringify(obj),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/*
POST /buyer-information/delete/:id?merchantId=:merchantId
Delete a buyer information profile by id
*/
export const DeleteBuyerInformation = (id, merchantId) => {
  return axios.post(
    `${WEBSERVICE}/buyer-information/delete/${id}?merchantId=${merchantId}`,
    JSON.stringify({}),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/* ─── Create Payment Link API ────────────────────────────────────────── */

/*
POST /payment/create
Saves a configured payment link to the backend and returns a server-issued paymentId.
 
Payload:
  merchantId        : number
  paymentName       : string
  paymentType       : "CHECKOUT"
  catalogId         : number
  shippingProfileId : number  (0 if not selected)
  buyerProfileId    : number
  billingId         : number
  discountProfileId : number  (0 if not selected)
*/
export const SavePaymentLink = (obj) => {
  return axios.post(
    WEBSERVICE + "/payment/create",
    JSON.stringify(obj),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/*
GET /payment/getPaymentLinks/:merchantId
Fetch the list of previously created payment links for a merchant.
*/
export const GetPaymentLinks = (merchantId) => {
  return axios.get(
    `${WEBSERVICE}/payment/getPaymentLinks/${merchantId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/*
POST /payment/deletePaymentLink
Delete a saved payment link by paymentId.
*/
export const DeletePaymentLink = (obj) => {
  return axios.post(
    WEBSERVICE + "/payment/deletePaymentLink",
    JSON.stringify(obj),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const IpGeo = () => {
  return axios.get(
    `https://api.ipgeolocation.io/ipgeo?apiKey=693da481af1b4a3e80e3dfea9115dc52`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

// Add this function to your service.js file
export const CreateQuickPaymentProduct = (payload) => {
  return axios.post(
    WEBSERVICE + "/shopping/products/register",
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const MarkAsTestTransaction = (payload) => {
  return axios.put(
    WEBSERVICE + "/api/transactions/markAsTestTxn",
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const ExportTransactionsCSV = (payload) => {
  return axios.post(
    WEBSERVICE + "/api/transactions/export",
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
      responseType: "blob", // Important for file download
    }
  );
};

export const CreateWebhookEndpoint = (payload) => {
  return axios.post(
    WEBSERVICE + "/merchantwebhooks/endpoints",
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetWebhookEndpoints = (merchantId) => {
  return axios.get(
    WEBSERVICE + "/merchantwebhooks/endpoints?merchantId=" + merchantId,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetWebhookEvents = () => {
  return axios.get(WEBSERVICE + "/merchantwebhooks/events", {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const GetWebhookEndpointById = (epId) => {
  return axios.get(WEBSERVICE + "/merchantwebhooks/endpoints/" + epId, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const DeleteWebhookEndpoint = (epId) => {
  return axios.post(
    WEBSERVICE + "/merchantwebhooks/deleteEndpoints/" + epId,
    JSON.stringify({}),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetWebhookFilterOptions = (merchantId) => {
  return axios.get(
    WEBSERVICE + "/merchantwebhooks/filter-options?merchantId=" + merchantId,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetWebhookLogById = (logId) => {
  return axios.get(WEBSERVICE + "/merchantwebhooks/logs/" + logId, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

// Updated service function for GetWebhookLogs
export const GetWebhookLogs = (merchantId, fromDate, toDate, page = 0, size = 20) => {
  return axios.get(
    `${WEBSERVICE}/merchantwebhooks/logs`,
    {
      params: {
        merchantId: merchantId,
        fromDate: fromDate,
        toDate: toDate,
        page: page,
        size: size
      },
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/*
  PROVISION — RetryWebhookLog (API pending)
  POST /merchantwebhooks/logs/:logId/retry
  Retries a failed webhook delivery.

export const RetryWebhookLog = (logId) => {
  return axios.post(
    WEBSERVICE + "/merchantwebhooks/logs/" + logId + "/retry",
    JSON.stringify({}),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};
*/

/*
Method definition for Update Webhook Endpoint API
POST /merchantwebhooks/updateEndpoints/:epId
Updates an existing webhook endpoint's configuration and event subscriptions.

Payload:
  endpoint.url          : string  — new endpoint URL
  endpoint.description  : string  — human-readable label
  endpoint.eventsMode   : "all" | "select"
  endpoint.retryEnabled : "Y" | "N"
  endpoint.maxRetries   : number
  endpoint.timeoutSec   : number
  endpoint.status       : "Active" | "Disabled"
  events                : string[] — list of event names (ignored when eventsMode is "all")
*/
export const UpdateWebhookEndpoint = (epId, payload) => {
  return axios.post(
    WEBSERVICE + "/merchantwebhooks/updateEndpoints/" + epId,
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const RetryWebhookLog = (epId, payload) => {
  return axios.post(
    WEBSERVICE + `/merchantwebhooks/logs/${epId}/retry`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/*
 * Get active reward campaigns for a merchant based on total purchase price
 * Public endpoint — no auth required
 */
export const GetActiveCampaigns = (merchantId, totalPurchasedPrice) => {
  return axios.get(
    WEBSERVICE +
    `/campaigns/active?merchantId=${encodeURIComponent(
      merchantId
    )}&totalPurchasedPrice=${encodeURIComponent(totalPurchasedPrice)}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

/*
 * Calculate and record reward after a successful payment
 * rewardFlag: 1 if reward was applied, 0 if not
 * Public endpoint — no auth required
 */
export const SubmitKyc = (formData) => {
  return axios.post(WEBSERVICE + "/kyc/submitKyc", formData, {
    headers: {
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const CalculateReward = (paymentId, campaignId, rewardFlag) => {
  return axios.post(
    WEBSERVICE +
    `/campaigns/calculate-reward?paymentId=${encodeURIComponent(
      paymentId
    )}&campaignId=${encodeURIComponent(campaignId)}&rewardFlag=${rewardFlag}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

/*
 * Get wallet balance for the logged-in user
 * Returns available balance that can be redeemed at checkout
 */
export const GetWalletBalance = (merchantId, customerId, currency = "USD") => {
  return axios.get(
    WEBSERVICE +
    `/campaigns/customer-settlement-ledger?customerId=${encodeURIComponent(
      customerId
    )}&merchantId=${encodeURIComponent(
      merchantId
    )}&currencyCode=${encodeURIComponent(currency)}`,
    headers
  );
};

/*
 * Fetch auto-withdrawal rules for a merchant
 */
export const GetAutoWithdrawal = (merchantId) => {
  return fetch(
    WEBSERVICE + `/merchant/auto-withdrawal?merchantId=${encodeURIComponent(merchantId)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  ).then((response) => {
    if (!response.ok) {
      return response
        .json()
        .catch(() => {
          throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
        })
        .then((errData) => {
          throw new Error(
            errData.message || `HTTP error ${response.status}: ${response.statusText}`
          );
        });
    }
    return response.json();
  });
};

/*
 * Delete an auto-withdrawal rule by id and merchantId
 */
export const DeleteAutoWithdrawal = (id, merchantId) => {
  return fetch(
    WEBSERVICE +
    `/merchant/auto-withdrawal?id=${encodeURIComponent(id)}&merchantId=${encodeURIComponent(merchantId)}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  ).then((response) => {
    if (!response.ok) {
      return response
        .json()
        .catch(() => {
          throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
        })
        .then((errData) => {
          throw new Error(
            errData.message || `HTTP error ${response.status}: ${response.statusText}`
          );
        });
    }
    return response.json();
  });
};

/*
 * Save auto-withdrawal settings for a merchant
 * withdrawalType: PLATFORM_WALLET | EXTERNAL_WALLET | BANK_ACCOUNT
 */
export const SaveAutoWithdrawal = (obj) => {
  var payload = JSON.stringify(obj);

  return fetch(WEBSERVICE + "/merchant/auto-withdrawal", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
    body: payload,
  }).then((response) => {
    if (!response.ok) {
      return response.json().catch(() => {
        throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
      }).then((errData) => {
        throw new Error(
          errData.message || `HTTP error ${response.status}: ${response.statusText}`
        );
      });
    }
    return response.json();
  });
};

export const GetReferralLink = (merchantId) => {
  return axios.get(`${WEBSERVICE}/referral/link?merchantId=${merchantId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const SendReferralEmail = (emails, merchantId) => {
  return axios.post(
    `${WEBSERVICE}/referral/send-emails`,
    {
      merchantId: merchantId,
      emails: emails,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetMonthlyReferralEarnings = (merchantId) => {
  return axios.get(
    `${WEBSERVICE}/referral/monthly-earnings?merchantId=${merchantId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetReferralStats = (merchantId) => {
  return axios.get(`${WEBSERVICE}/referral/stats?merchantId=${merchantId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
};

export const GetReferredMerchants = (merchantId, offset = 0, limit = 10) => {
  return axios.get(
    `${WEBSERVICE}/referral/referred-merchants?merchantId=${merchantId}&offset=${offset}&limit=${limit}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetReferralEarningHistory = (merchantId, offset = 1, limit = 10) => {
  return axios.get(
    `${WEBSERVICE}/referral/earning-history?merchantId=${merchantId}&offset=${offset}&limit=${limit}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetReferralMilestoneProgress = (merchantId) => {
  return axios.get(
    `${WEBSERVICE}/referral/milestone-progress?merchantId=${merchantId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const fetchEscrowContractDetails = async (contractNo, merchantId) => {
  const url = `${WEBSERVICE}/escrow/contract/details?merchantId=${merchantId}&contractNo=${encodeURIComponent(contractNo)}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "bearer " + getAuthToken(),
      UUID: getAuthUuid(),
    },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const getMerchantCardApplications = (merchantId, uuid) => {
  return axios.get(
    `${WEBSERVICE}/merchant/getMerchantCardApplications?merchantId=${merchantId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
    }
  );
};

export const GetAllInstalledApps = (userUuid) => {
  const token = getAuthToken();
  const uuid =
    userUuid ||
    localStorage.getItem(SITENAMEALIAS + "_merchant_uuid") ||
    localStorage.getItem("bill_bitcoins_merchant_uuid") ||
    getAuthUuid();
  return axios.post(
    `${WEBSERVICE}/app/getAllInstalledApp`,
    JSON.stringify({ merchant_uuid: uuid }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
        UUID: uuid,
      },
    }
  );
};

